import {
	coalDigger,
	hackingUsb,
	polydactylism,
	ravenousLawyers,
	recyclingPlant,
	regulatoryCapture,
} from '@lc/const/modifiers';
import { createCardEquipment } from '@lc/interface/card/equipment/factory';

export const EquipmentMeta = [
	createCardEquipment(
		31,
		1,
		`TEAM OF RAVENOUS LAWYERS`,
		`PLAY THIS CARD IN FRONT OF YOU. DISCARD THIS CARD TO LOOK THROUGH A NEIGHBOR’S HAND AND STEAL A CARD OF YOUR CHOICE`,
		`“THE JURY IS OUT. WE ATE THEM.”`,
		ravenousLawyers,
		true,
		false,
		true
	),
	createCardEquipment(
		32,
		1,
		`TEAM OF RAVENOUS LAWYERS`,
		`PLAY THIS CARD IN FRONT OF YOU. DISCARD THIS CARD TO LOOK THROUGH A NEIGHBOR’S HAND AND STEAL A CARD OF YOUR CHOICE`,
		`“THE JURY IS OUT. WE ATE THEM.”`,
		ravenousLawyers,
		true,
		false,
		true
	),
	createCardEquipment(
		33,
		2,
		`RECYCLING PLANT`,
		`DISCARD A CARD TO DRAW A CARD ONCE PER MONTH **LIMIT ONE (1) PER PLAYER**`,
		`“THE BINS ARE COLOR CODED BY RACCOON RESISTANCE LEVEL.”`,
		recyclingPlant,
		false,
		false,
		false,
		true
	),
	createCardEquipment(
		34,
		2,
		`RECYCLING PLANT`,
		`DISCARD A CARD TO DRAW A CARD ONCE PER MONTH **LIMIT ONE (1) PER PLAYER**`,
		`“THE BINS ARE COLOR CODED BY RACCOON RESISTANCE LEVEL.”`,
		recyclingPlant,
		false,
		false,
		false,
		true
	),
	createCardEquipment(
		35,
		1,
		`POLYDACTYLISM`,
		`INCREASE YOUR HAND SIZE BY ONE (1) FOR THE REST OF THE GAME. YOU MAY DRAW A CARD WHEN THIS CARD IS PLAYED`,
		`“I’M MORE OF A MITTEN GUY.”`,
		polydactylism
	),
	createCardEquipment(
		36,
		1,
		`POLYDACTYLISM`,
		`INCREASE YOUR HAND SIZE BY ONE (1) FOR THE REST OF THE GAME. YOU MAY DRAW A CARD WHEN THIS CARD IS PLAYED`,
		`“I’M MORE OF A MITTEN GUY.”`,
		polydactylism
	),
	createCardEquipment(
		37,
		1,
		`HACKING USB`,
		`PLAY THIS CARD IN FRONT OF YOU STARTING NEXT MONTH, YOU MAY DISCARD THIS CARD TO MAKE TWO PLAYERS SWITCH HANDS (YOU MAY BE ONE OF THESE PLAYERS)`,
		`“SCIENTISTS STILL AREN’T SURE WHICH SIDE IS UP.”`,
		hackingUsb,
		true,
		true,
		true
	),
	createCardEquipment(
		38,
		2,
		`REGULATORY CAPTURE`,
		`ONCE PER SEASON, LOOK AT THE TOP FIVE (5) CARDS OF THE SEASONAL DECK AND PICK ONE TO KEEP SHUFFLE THE OTHER CARDS AND PLACE THEM BACK ON THE TOP OF THE DECK`,
		`“GOTTA CATCH ‘EM ALL”`,
		regulatoryCapture
	),
	createCardEquipment(
		39,
		2,
		`COAL DIGGER`,
		`ONCE PER TURN YOU MAY TAKE ONE (1) CARBON FROM ANY PLAYER’S CARBON RESERVE AND PUT IT BACK INTO THE CARBON POOL`,
		`“SHE TAKE MY CARBON WHEN I’M IN NEED.”`,
		coalDigger,
		true
	),
];
